import { EyeIcon, EyeOffIcon } from 'lucide-react'
import React, { forwardRef, useState } from 'react'

import { cn } from 'utils'

import { SolidCircleCheckIcon } from './icons/SolidCircleCheck'
import { TextLikeFormField, type TextLikeFormFieldProps } from './TextLikeFormField'

export interface PasswordInputProps
  extends Omit<TextLikeFormFieldProps, 'className' | 'children'>,
  React.InputHTMLAttributes<HTMLInputElement> {
  disabled?: boolean;
  placeholder?: string;
  validated?: boolean;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(({ validated, ...props }, forwardedRef) => {
  const [visible, setVisible] = useState(false)

  return (
    <TextLikeFormField {...props}>
      {(formFieldProps) => (
        <>
          <input
            {...formFieldProps}
            className={cn(formFieldProps.className, {
              'pr-8': !validated,
              'pr-12': validated,
            })}
            ref={forwardedRef}
            type={visible ? 'text' : 'password'}
          />
          {!props.disabled && (
            <div className='flex items-center absolute right-2 top-0 bottom-0'>
              <button
                aria-label={visible ? 'hide password' : 'show password'}
                type='button'
                className='appearance-none rounded-sm p-1 cursor-pointer text-gray-500 hover:text-gray-700 active:text-gray-800 outline-none focus-visible:ring ring-transparent focus-visible:ring-thatch-500 transition-all'
                onClick={() => {
                  setVisible((prev) => !prev)
                }}
              >
                {visible ? <EyeOffIcon aria-hidden size={16} /> : <EyeIcon aria-hidden size={16} />}
              </button>
              {validated && (
                <span className='pointer-events-none text-green-400'>
                  <SolidCircleCheckIcon size={16} />
                </span>
              )}
            </div>
          )}
        </>
      )}
    </TextLikeFormField>
  )
})
